import { Link } from 'react-router-dom';
import './ArticleListCard.css';

function ArticleListCard({ id, title, excerpt, date, imageUrl }) {
  const [day, month, year] = date.split('/').map(Number);
  const dateObj = new Date(year, month - 1, day);
  
  return (
    <Link to={`/articles/${id}`} className="article-list-card">
      {imageUrl && (
        <div className="article-list-image">
          <img src={imageUrl} alt={title} />
        </div>
      )}
      <div className="article-list-date">
        {dateObj.toLocaleDateString('it-IT', { 
          day: 'numeric', 
          month: 'short' 
        })}
      </div>
      <div className="article-list-content">
        <h4>{title}</h4>
        {excerpt && (
          <p className="article-list-excerpt">{excerpt}</p>
        )}
      </div>
    </Link>
  );
}

export default ArticleListCard;
